import React from 'react';
import { ApiError } from '../../../../api/api';
import { ReadOnlyField } from '../../../../shared/form/ReadOnlyField';

type Props = {
  label: React.ReactNode;
  designMaterialsCalculationsInProgress: boolean;
  designMaterialsCalculationsError: ApiError | null;
  value: string | null;
};

export const DesignMaterialsCalculationReadOnlyField = ({
  label,
  designMaterialsCalculationsInProgress,
  designMaterialsCalculationsError,
  value,
}: Props) => (
  <ReadOnlyField
    label={label}
    value={
      designMaterialsCalculationsInProgress
        ? 'Calculating...'
        : designMaterialsCalculationsError != null
        ? 'Error'
        : value != null && value !== 'NaN'
        ? value
        : '?'
    }
    showError={designMaterialsCalculationsError != null}
    error={
      designMaterialsCalculationsError &&
      (designMaterialsCalculationsError.userVisibleMessage || 'Failed to perform calculations')
    }
  />
);
